import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { client } from "../config/prismic";

const Header = ({ page = false }) => {
  const [home, setHome] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("home");
      setHome(response.results[0]?.data); // Accessing the first result's data directly
    };
    fetchData();
  }, []);

  if (!home) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  function mobileNavView() {
    const div = document.querySelector("#navbar");
    div.classList.remove("navbar");
    div.classList.toggle("navbar-mobile");
  }

  const handleScroll = (ref) => {
    window.scrollTo({
      top: ref.offsetTop,
      left: 0,
      behavior: "smooth",
    });
    const div = document.querySelector("#navbar");
    div.classList.add("navbar");
    div.classList.remove("navbar-mobile");
  };

  const handleScrollAbout = (ref) => {
    window.scrollTo({
      top: ref.offsetTop + 700,
      left: 0,
      behavior: "smooth",
    });
    const div = document.querySelector("#navbar");
    div.classList.remove("navbar-mobile");
    div.classList.add("navbar");
  };

  return (
    <div>
      <header
        id="header"
        className={`fixed-top d-flex align-items-center ${
          page ? "bg-dark-blue" : ""
        }`}
        style={{
          backgroundColor: page ? "" : "rgba(0, 0, 0, 0)",
        }}
      >
        <div className="container d-flex align-items-center justify-content-between">
          <div className="logo mt-4 pt-4">
            <a href="/">
              {/* Use the logo from the home object */}
              <img
                src={home.logo1.url} // Use home.logo2.url if you prefer that logo
                alt="Conference Logo"
                className="img-fluid logo-img1"
              />
            </a>
          </div>

          <nav id="navbar" className="navbar">
            <ul>
              <li>
                <Link className="nav-link link-button scrollto" to="/">
                  Home
                </Link>
              </li>
              <li>
                <Link className="nav-link link-button scrollto" to="/cfp">
                  Call for Papers
                </Link>
              </li>
              <li>
                <Link
                  className="nav-link link-button scrollto"
                  to="/guidelines"
                >
                  Guidelines
                </Link>
              </li>
              <li>
                <Link className="nav-link link-button scrollto" to="/committee">
                  Committee
                </Link>
              </li>
              {/* <li>
                <Link
                  className="nav-link link-button scrollto"
                  to="/special-session"
                >
                  Special Session
                </Link>
              </li> */}
              <li>
                <Link className="nav-link link-button scrollto" to="/past-conf">
                  Past Conferences
                </Link>
              </li>
              <li>
                <a
                  className="nav-link link-button scrollto px-4"
                  target="_blank"
                  href={home.registration_link[0].text}
                >
                  <button className="btn register-btn nav-btn nav-btn-mobile">
                    Registration
                  </button>
                </a>
              </li>
            </ul>
            <button onClick={mobileNavView} className="mobile-nav-toggle">
              <img
                width="30"
                height="30"
                src="https://img.icons8.com/ios-glyphs/30/FFFFFF/menu--v1.png"
                alt="menu--v1"
              />
            </button>
          </nav>
          <div className="logo px-4 mt-4 pt-4">
            <a href="/">
              {/* Use the logo from the home object */}
              <img
                src={home.logo2.url} // Use home.logo2.url if you prefer that logo
                alt="Conference Logo"
                className="img-fluid logo-img1"
              />
            </a>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
